<template>
  <transition name="el-fade-in-linear">
    <div class="search-box flex-center" v-if="isSearch">
      <div class="bg" @click="close"></div>
      <div class="search color-bg-fff flex-center">
        <el-input v-model="searchKey" placeholder="请输入关键词进行搜索，如班次、订单、订票等" class="margin-left-20 font-16"
          @keyup.enter.native="searchChange"></el-input>
        <div class="search-btn flex-center" @click.stop="searchChange">
          <img style="width: 28px;height: 28px;" src="./static/icon_home_search.png">
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  data() {
    return {
      isSearch: false,
      searchKey: ''
    }
  },
  mounted() {
    this.keyDown() // 监听键盘
  },
  methods: {
    searchChange() {
      if (!this.searchKey) {
        this.$message.warning('请输入关键词！')
        return
      }
      this.$store.commit('UPDATE_ARTICLE_SEARCHKEY', this.searchKey)
      this.$router.push({
        path: `/articleSearch`
      })
      this.isSearch = false
    },
    close() {
      this.isSearch = false
    },
    keyDown() {
      document.onkeydown = (e) => {
        if (navigator.platform.match("Mac") ? e.metaKey : e.ctrlKey) {
          if (e.code === "KeyK") {
            // 在 Windows 或 macOS 上按下了 Ctrl + K 或 Command + K
            if (navigator.platform.match("Mac")) {
              this.isSearch = true
              // 在 macOS 上按下了 Command + K
            } else {
              this.isSearch = true
              // 在 Windows 上按下了 Ctrl + K
            }
          }
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.search-box {
  z-index: 99999;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  .bg {
    width: 100%;
    height: 100%;
    position: absolute;
    background-color: rgba(0, 0, 0, 0.4);
  }

  .search {
    z-index: 1000;
    transition: all 0.3s linear;
    width: 40%;
    height: 60px;
    margin-bottom: 200px;
    border-radius: 42px;
    box-shadow: 0px 0px 22px 1px rgba(0, 0, 0, 0.10);

    ::v-deep .el-input__inner {
      border: none !important;
      box-shadow: none !important;
      padding: 0px; //前边边距去掉
    }

    .search-btn {
      height: 100%;
      width: 20%;
      background-color: #4292FF;
      border-radius: 0px 42px 42px 0px;
      box-shadow: 0px 0px 22px 1px rgba(0, 0, 0, 0.05);
    }
  }
}
</style>